import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Button } from '../components/ui/Button';
import { products } from '../data/products';
export function ContactPage() {
  const [formState, setFormState] = useState({
    name: '',
    company: '',
    email: '',
    message: '',
    selectedProducts: [] as string[]
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleProductToggle = (productId: string) => {
    setFormState(prev => {
      if (prev.selectedProducts.includes(productId)) {
        return {
          ...prev,
          selectedProducts: prev.selectedProducts.filter(id => id !== productId)
        };
      } else {
        return {
          ...prev,
          selectedProducts: [...prev.selectedProducts, productId]
        };
      }
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      console.log('Form submitted:', formState);
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <div className="pt-32 pb-20 bg-slate-50 min-h-screen" data-id="element-270">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
        <SectionHeading title="Request a Demo" description="See how NexusFlow can transform your business operations." className="mb-12" data-id="element-272" />

        {isSuccess ? <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-white rounded-2xl p-12 text-center shadow-sm border border-slate-200" data-id="element-273">
            <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-274">
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-275">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-276" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-277">
              Request Received!
            </h3>
            <p className="text-slate-600 mb-8" data-id="element-278">
              Thank you for your interest. Our team will be in touch within 24
              hours to schedule your personalized demo.
            </p>
            <Button href="/" variant="outline" data-id="element-279">
              Back to Home
            </Button>
          </motion.div> : <motion.form initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-slate-200" onSubmit={handleSubmit} data-id="element-280">
            <div className="space-y-6" data-id="element-281">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-282">
                <div data-id="element-283">
                  <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-284">
                    Full Name
                  </label>
                  <input type="text" id="name" required className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-navy-500 focus:border-navy-500 outline-none transition-all" placeholder="John Doe" value={formState.name} onChange={e => setFormState({
                ...formState,
                name: e.target.value
              })} data-id="element-285" />
                </div>
                <div data-id="element-286">
                  <label htmlFor="company" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-287">
                    Company Name
                  </label>
                  <input type="text" id="company" required className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-navy-500 focus:border-navy-500 outline-none transition-all" placeholder="Acme Inc." value={formState.company} onChange={e => setFormState({
                ...formState,
                company: e.target.value
              })} data-id="element-288" />
                </div>
              </div>

              <div data-id="element-289">
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-290">
                  Work Email
                </label>
                <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-navy-500 focus:border-navy-500 outline-none transition-all" placeholder="john@company.com" value={formState.email} onChange={e => setFormState({
              ...formState,
              email: e.target.value
            })} data-id="element-291" />
              </div>

              <div data-id="element-292">
                <label className="block text-sm font-medium text-slate-700 mb-3" data-id="element-293">
                  Products of Interest
                </label>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-294">
                  {products.map(product => <div key={product.id} onClick={() => handleProductToggle(product.id)} className={`cursor-pointer px-3 py-2 rounded-lg border text-sm font-medium transition-all ${formState.selectedProducts.includes(product.id) ? 'bg-navy-50 border-navy-500 text-navy-700' : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300'}`} data-id="element-295">
                      {product.name}
                    </div>)}
                </div>
              </div>

              <div data-id="element-296">
                <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-297">
                  Message (Optional)
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-navy-500 focus:border-navy-500 outline-none transition-all resize-none" placeholder="Tell us about your needs..." value={formState.message} onChange={e => setFormState({
              ...formState,
              message: e.target.value
            })} data-id="element-298"></textarea>
              </div>

              <Button type="submit" fullWidth size="lg" disabled={isSubmitting} className="mt-4" data-id="element-299">
                {isSubmitting ? 'Sending...' : 'Submit Request'}
              </Button>

              <p className="text-xs text-center text-slate-500 mt-4" data-id="element-300">
                Our team typically responds within 24–48 hours. By submitting
                this form, you agree to our privacy policy.
              </p>
            </div>
          </motion.form>}
      </div>
    </div>;
}